import { DtoConversionError, RequestEntity } from "..";
import OutputNewsSummary from "./summary";

export default class OutputNewsDetail extends OutputNewsSummary {
  constructor(
    id: number,
    name: string,
    title: string,
    content: string,
    date: Date,
    front_img: string,
    hidden: boolean,
    public readonly back_img: string,
    public readonly facebook: string,
    public readonly instagram: string,
    public readonly hashtags: string[],
    public readonly related: OutputNewsSummary[]
  ) {
    super(id, name, title, content, date, front_img, hidden);
  }

  static convert(input: any): OutputNewsDetail {
    if (input instanceof OutputNewsDetail) return input;

    const back_img = input.back_img ?? undefined;
    const facebook = input.facebook ?? undefined;
    const instagram = input.instagram ?? undefined;
    const hashtags = input.hashtags ?? undefined;
    const related = input.related ?? undefined;

    if (typeof back_img !== "string")
      throw new OutputNewsDetailConversionError("back_img", input);
    if (typeof facebook !== "string")
      throw new OutputNewsDetailConversionError("facebook", input);
    if (typeof instagram !== "string")
      throw new OutputNewsDetailConversionError("instagram", input);

    if (!Array.isArray(hashtags))
      throw new OutputNewsDetailConversionError("hashtags", input);
    hashtags.forEach((element) => {
      if (typeof element !== "string")
        throw new OutputNewsDetailConversionError("hashtags", input);
    });

    if (!Array.isArray(related))
      throw new OutputNewsDetailConversionError("related", input);

    return OutputNewsDetailConversionError.propagate(
      OutputNewsDetailConversionError.dtoName,
      () => {
        const base = OutputNewsSummary.convert(input);

        return new OutputNewsDetail(
          base.id,
          base.name,
          base.title,
          base.content,
          base.date,
          base.front_img,
          base.hidden,
          back_img,
          facebook,
          instagram,
          hashtags,
          related.map((element) => OutputNewsSummary.convert(element))
        );
      }
    );
  }
}

class OutputNewsDetailConversionError extends DtoConversionError {
  public static dtoName: string = "OutputNewsDetail";
  constructor(propertyName: string, rawData: any, hint?: string) {
    super(OutputNewsDetailConversionError.dtoName, propertyName, rawData, hint);
  }
}

export class RequestNewsDetailByName extends RequestEntity {
  constructor(public readonly name: string) {
    super();
  }
}
